import { render, staticRenderFns } from "./SelectRef.vue?vue&type=template&id=0aeee680"
import script from "./SelectRef.vue?vue&type=script&lang=ts"
export * from "./SelectRef.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports